export const NavItemsList = [

    {   id: 1,
        title: "Project",
        state: "project"
    },
    {   id: 2,
        title: "Wet Lab",
        state: "wetLab"
    },
    {   id: 3,
        title: "Dry Lab",
        state: "dryLab"
    },
    {   id: 4,
        title: "Human Practices",
        state: "hp"
    },
    {   id: 5,
        title: "Team",
        state: "team"
    },
    {
        id: 6,
        title: "Memes",
        link: "/meme-gallery",
    }
]